<template>
  <teleport to="#modal_backdrop">
    <div @click="$emit('exit-modal')" class="backdrop-popup"></div>
    <div class="download-app-content">
      <button class="close-button" @click="$emit('exit-modal')">
        <v-icon icon="mdi-close" />
      </button>
      <div
        class="main-page-content ma-auto d-flex flex-column justify-center align-center ga-5"
      >
        <h1 class="label-title">{{ $t("DownloadAppPage.contentTitle") }}</h1>
        <p>
          {{ `${getUserName}, ` + $t("DownloadAppPage.contentSubTitle") }}
        </p>
      </div>
      <ButtonContainer
        style="width: 90%"
        mode="downloadApp"
        :loading="loading"
        :textSize="isMobile ? '18px' : '20px'"
        :buttonText="$t('DownloadAppPage.installButton')"
        @click="bottomSheet = true"
      />
    </div>
    <InstallGuideSheet v-model="bottomSheet" />
  </teleport>
</template>

<script>
import ButtonContainer from "../UI/ButtonContainer.vue";
import { mapGetters } from "vuex";
import InstallGuideSheet from "./InstallGuideSheet.vue";

export default {
  emits: ["exit-modal"],
  components: {
    ButtonContainer,
    InstallGuideSheet,
  },
  data() {
    return {
      bottomSheet: false,
    };
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
      getUserName: "AuthModule/getUserName",
    }),
  },
};
</script>

<style scoped lang="scss">
.backdrop-popup {
  background-color: #5a5a5ab9;
  opacity: 0.6;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  z-index: 12;
}
.download-app-content {
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  z-index: 12;
  font-size: $mediumTextSize;
  border-radius: 40px;
  background: #ffffff;
  padding: 20px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 450px;
  max-height: 90vh;
  min-height: 300px;
  height: auto;
  overflow: hidden;
}
h1 {
  color: $blackColor;
  margin-bottom: 0px;
  margin-top: 0px;
}

p {
  font-size: $mediumTextSize;
  color: #7c7c7c;
}

.main-page-content {
  width: 100%;
  height: 100%;
  h1 {
    font-size: $h1TextTitleSize;
  }
  p {
    width: 80%;
    text-align: center;
    font-size: $mediumTextSize;
    color: #7c7c7c;
  }

  @media (max-width: 601px) {
    h1 {
      font-size: 30px;
    }
  }
}

.close-button {
  position: absolute;
  top: 10px;
  left: 15px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .v-icon {
    color: $blackColor;
    font-size: 24px;
  }
}
</style>
